<template lang="pug">
.generator
  image-generator
</template>

<script>
// import debug from 'debug'
import ImageGenerator from '../components/ImageGenerator'

// const log = debug('view:Generator')

export default {
  name: 'Generator',
  components: { ImageGenerator },
}
</script>

<style lang="scss" scoped>
// .generator {}
</style>
